import { BookOpen } from "@phosphor-icons/react";
import { Eyebrow } from "@/components/ui";
import { TakeCard } from "./TakeCard";
import type { Take } from "@/types";

interface TakeListProps {
  takes: Take[];
  loading: boolean;
}

export function TakeList({ takes, loading }: TakeListProps) {
  if (loading) return null;

  if (takes.length === 0) {
    return (
      <div className="mt-12 text-center py-16">
        <BookOpen size={40} weight="duotone" className="mx-auto text-walnut-soft" />
        <Eyebrow withDot className="block mt-4">No source yet</Eyebrow>
        <p className="mt-3 font-text text-t-16 leading-as-read text-ink-2 max-w-md mx-auto">
          The book starts when the first piece of source arrives: a voice note,
          a draft, a transcript, an outline, or a page you do not want to lose.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-10">
      <Eyebrow withDot className="block mb-[16px]">
        Source material · {takes.length} source{takes.length !== 1 ? "s" : ""}
      </Eyebrow>
      <div className="space-y-3">
        {takes.map((take) => (
          <TakeCard key={take.id} take={take} />
        ))}
      </div>
    </div>
  );
}
